import React, {useState} from 'react';
import ReportMasterMediaSearch from './ReportMasterMediaSearch';

const SearchMediaReportMasterContainer = ({setValue, handleClose, setBreCode, setRuleCode, handleDialog}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchData, setSearchData] = useState({});

  return (
    <>
      <ReportMasterMediaSearch
        setValue={setValue}
        setBreCode={setBreCode}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        searchData={searchData}
        handleClose={handleClose}
        setSearchData={setSearchData}
        setRuleCode={setRuleCode}
        handleDialog={handleDialog}
      />
    </>
  );
};
export default SearchMediaReportMasterContainer;
